/* NOSEKNOWS product page ADD button gate + apply form visibility
   /apps/nk/status を取得して、
   - 当選者(ACTIVE)なら ADD 解放
   - 期限切れ/購入/応募済の関連drop なら APPLY フォームを隠して状態メッセージ表示
   - それ以外は LOCKED + APPLY 表示のまま
*/
(function () {
  "use strict";

  var btn = document.getElementById("nk-add-btn");
  var applyForm = document.querySelector(".nk-apply-form");
  var dropId = btn ? btn.dataset.nkDropId : null;
  if (!dropId) return;

  function hideApplyForm(messageText) {
    if (!applyForm) return;
    applyForm.style.display = "none";
    // 代替メッセージを直下に差し込む
    if (!document.getElementById("nk-apply-replacement")) {
      var msg = document.createElement("div");
      msg.id = "nk-apply-replacement";
      msg.className = "nk-meta";
      msg.style.cssText = "margin-top:10px; font-size:11px; color:var(--c1); letter-spacing:.18em; line-height:1.6;";
      msg.textContent = messageText;
      applyForm.parentNode.insertBefore(msg, applyForm.nextSibling);
    }
  }

  // 商品自体が在庫切れ/SOLD OUTの場合はAPPLY制御のみ（ADDは触らない）
  var productUnavailable = btn.dataset.productUnavailable === "true";

  fetch("/apps/nk/status")
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (!d.ok || !d.state) return;
      var kind = d.state.kind;
      var sameDropId = d.state.dropId === dropId;
      var matchingRight = Array.isArray(d.purchase_rights) && d.purchase_rights.some(function (right) {
        return right && right.drop_id === dropId && new Date(right.expires_at).getTime() > Date.now();
      });

      if (!productUnavailable) {
        // ACTIVE状態で、dropIdが一致する場合のみ購入可能
        if (matchingRight || (kind === "ACTIVE" && sameDropId)) {
          btn.disabled = false;
          btn.textContent = "ADD / カートへ";
        }
        // PURCHASED状態で同じdropの場合は「購入済み」と表示（押せない）
        else if (kind === "PURCHASED" && sameDropId) {
          btn.textContent = "PURCHASED / 購入済み";
        }
      }

      // APPLY フォーム表示制御（dropId一致時のみ）
      if (sameDropId || matchingRight) {
        if (matchingRight || kind === "ACTIVE") {
          hideApplyForm("購入可能です。期限内に購入ボタンからお進みください。");
        } else if (kind === "EXPIRED") {
          hideApplyForm("このDropの購入期限は終了しました。");
        } else if (kind === "PURCHASED") {
          hideApplyForm("この商品は購入済みです。");
        } else if (kind === "APPLIED") {
          hideApplyForm("このDropには応募済みです。結果をお待ちください。");
        }
      }
    })
    .catch(function () {
      // エラー時は初期状態（LOCKED + APPLYフォーム表示）のまま
    });
})();
